// CANONICAL COPY (GH #7115). src/constants/obligations/obl-physical-monitoring.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-physical-monitoring',
  title: 'Review physical security monitoring',
  description:
    'Confirm that premises are continuously or periodically monitored for unauthorised physical access (CCTV, alarm systems, intrusion detection, guarded reception). Monitoring records shall be retained and reviewed for anomalies.',
  category: 'assets',
  scfIds: ['SCF-PHY-004'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Physical monitoring procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
